import { props } from './syllabus-block-utils';
import Block from './block';

export default {
  props,

  template: '#instructors-block-template',

  components: {
    Block
  },

  data() {
    const combinedCourseFaculty = [
      ...(this.$root.course.professors || []).map(i => Object.assign(i, {
        role: 'instructor',
        presentationRole: Kadenze.I18n.n('Instructor'),
        rowKey: `${i.id}-instructor`
      })),

      ...(this.$root.course.guest_lecturers || []).map(i => Object.assign(i, {
        role: 'guest_lecturer',
        presentationRole: 'Guest Lecturer',
        rowKey: `${i.id}-guest_lecturer`
      })),

      ...(this.$root.course.tas || []).map(i => Object.assign(i, {
        role: 'ta',
        presentationRole: Kadenze.I18n.n('Teaching Assistant'),
        rowKey: `${i.id}-ta`
      })),


      ...(this.$root.course.instructional_supporters || []).map(i => Object.assign(i, {
        role: 'instructional-support',
        presentationRole: 'Instructional Support',
        rowKey: `${i.id}-instructional-supporter`
      })),

      ...(this.$root.course.graduate_supporters || []).map(i => Object.assign(i, {
        role: 'graduate-teaching-assistant',
        presentationRole: 'Graduate Teaching Assistant',
        rowKey: `${i.id}-graduate-teaching-assistants`
      })),

      ...(this.$root.course.staff || []).map(i => Object.assign(i, {
        role: 'staff',
        presentationRole: 'Staff',
        rowKey: `${i.id}-staff`
      })),
      ...(this.$root.course.mentors || []).map((i) => Object.assign(i, { 
        role: 'mentor',
        presentationRole: 'Mentor',
        rowKey: `${i.id}-mentor`
      })),
    ];

    const showFaculty = {};
    const showEmail = {};
    const showBio = {};

    combinedCourseFaculty.forEach(f => {
      showFaculty[f.rowKey] = (f.role == 'instructor');
      showEmail[f.rowKey] = false;
      showBio[f.rowKey] = false;
    });

    return Object.assign({
      title: '',
      combinedCourseFaculty,
      showFaculty,
      showEmail,
      showBio,
    }, this.rootData);
  },

  watch: {
    dataForSave: {
      handler () {
        this.$emit('block-update', this.dataForSave);
      },

      deep: true
    },
  },

  computed: {
    isEmpty() {
      return !_.values(this.showFaculty).reduce((acc, val) => acc || val, false);
    },

    dataForSave() {
      return {
        uuid: this.uuid,
        data: {
          title: this.title,
          showFaculty: this.showFaculty,
          showBio: this.showBio,
          showEmail: this.showEmail,
          showOnPublicSyllabus: this.showOnPublicSyllabus,
        }
      };
    }
  },

  methods: {
    navigateToInstructors() {
      let opts = {
        title: 'Are you sure you want to leave?',
        body: `You are about to leave the Syllabus Creator to edit your
        course instructors, any changes will be saved`,
        cancel_btn_text: 'Return To Builder',
        ok_btn_text: 'Save & Continue'
      };

      const path = Kadenze.Routes.course_instructors_path(this.$root.course.id);

      Kadenze.UIUtil.confirmAction(
        opts.body, () => {
          this.$root.save(() => window.location = path);
        }, null, opts
      );
    }
  },
};
